export const productionErrorComment = (json: IProductionErrorComment): IProductionErrorCommentModel => {
	const {
		id,
		mes_id,
		comment,
		crm_id,
		author_name,
		author_role,
		author_first_name,
		author_last_name,
		author_email,
		created_at,
	} = json

	return {
		id,
		comment,
		mesID: mes_id,
		crmID: crm_id,
		authorName: author_name,
		authorRole: author_role,
		authorFirstName: author_first_name ?? null,
		authorLastName: author_last_name ?? null,
		authorEmail: author_email ?? null,
		createdAt: new Date(created_at),
	}
}
